import { Icon } from "@/components/common/icon/Icon";

interface CellProps {
  iconType?: "check-fill" | "cross-fill" | "lock" | "cross-fill-gray";
  title: string;
  description?: string;
  valueTop?: number | string;
  valueTopSubtitle?: number | string;
  valueBottom?: number | string;
  middleClass?: string;
  baseClass?: string;
}

const Cell = ({
  iconType,
  title,
  description,
  valueTop,
  valueTopSubtitle,
  valueBottom,
  middleClass,
  baseClass,
}: CellProps) => {
  return (
    <div className={`w-full flex items-center gap-4 px-4 py-2 ${baseClass}`}>
      {iconType && (
        <div className="shrink-0 w-7 h-7 flex items-center justify-center">
          <Icon
            type={iconType}
            className={`shrink-0 ${
              !["check-fill", "cross-fill", "cross-fill-gray"].includes(
                iconType
              )
                ? "fill-link w-5 h-5"
                : "w-7 h-7"
            }`}
          />
        </div>
      )}
      <div className={`flex-1 flex flex-col gap-0.5 py-3 ${middleClass}`}>
        <p className="text-[1.0625rem] leading-[1.375rem] tracking-tight">
          {title}
        </p>
        {description && (
          <p className="text-[0.8125rem] leading-[1rem] text-subtitle-text">
            {description}
          </p>
        )}
      </div>
      <div className="shrink-0 flex flex-col items-end gap-0.5">
        {valueTopSubtitle && (
          <p className="text-[1.0625rem] leading-[1.375rem] text-subtitle-text">
            {valueTopSubtitle}
          </p>
        )}
        {valueTop && (
          <p className="text-[1.0625rem] leading-[1.375rem]">{valueTop}</p>
        )}
        {valueBottom && (
          <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
            {valueBottom}
          </p>
        )}
      </div>
    </div>
  );
};

export default Cell;
